import {useState, useEffect,Fragment} from 'react';
import { Box, TextField, useTheme } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import Autocomplete from '@mui/material/Autocomplete';
import CircularProgress from '@mui/material/CircularProgress';
import ContactosService from '../../services/contactos.service';
import CardSearchNav from '../card/CardSearchNav';
import TratoService from '../../services/tratos.service';

const InputSearchIdCompleto = ({value,disabled,onChange,isClearable,errorText,onClick,borderChange, ...props}) => {
    const theme = useTheme();
    const isDarkMode = theme.palette.mode === 'dark';

    const [textSearch, setTextSearch] = useState('');
    const [options, setOptions] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const handleSearchContacto = async(query) => {
        setIsLoading(true);
        await TratoService.getAll({searchNubi: query,typoSearch: 'softCompleto'}).then((data)=>{
            setOptions( data.map((item) =>{
                if(!item?.cuenta){
                    return {
                        ...item,
                        tituloCard: `${item?.id_t} - ${item?.nombre_t}`,
                        descripCard: `Pre-Servicio - ${item?.direccion_t || 'S/D'} - ${item?.categoria_t || ''}`,
                        empresaCard: 'NUBICOM',
                        keyCard: `${item?.id_t}preS`
                    }
                }
                return {
                    ...item,
                    tituloCard: `${item?.id_t} - ${item?.nombre_t}`,
                    descripCard: `Softland - ${item?.direccion_servicio || 'S/D'} - ${item?.segmento || ''}`,
                    empresaCard: 'NUBICOM',
                    keyCard: `${item?.id_t}dirent`
                }
            }))
        })
        .finally(() => {
            setIsLoading(false);
        });
    };

    useEffect(() => {
        if(textSearch?.length > 2){
            const delayWrite = setTimeout(() => {
                handleSearchContacto(textSearch)
            }, 600)
            return () => clearTimeout(delayWrite)
        }
    }, [textSearch])

    return (
        <Box sx={{display: 'flex'}}>
            <Autocomplete
                id="asynchronous-demo"
                freeSolo
                isOptionEqualToValue={(option, value) => option?.tituloCard === value?.tituloCard}
                getOptionLabel={(option) => `${option?.tituloCard} ${option?.descripCard}`}
                options={options}
                filterOptions={(options) => options}
                loading={isLoading}
                disableClearable
                fullWidth
                componentsProps={{
                    paper: {
                        sx: {
                            backgroundColor: isDarkMode ? '#1F2A40' : '#fff',
                            border: isDarkMode ? '1px solid #3d4a62' : '1px solid #e0e0e0',
                            boxShadow: isDarkMode ? '0 4px 20px rgba(0,0,0,0.5)' : '0 4px 20px rgba(0,0,0,0.15)',
                            '& .MuiAutocomplete-listbox': {
                                backgroundColor: isDarkMode ? '#1F2A40' : '#fff',
                                padding: '4px',
                            },
                            '& .MuiAutocomplete-option': {
                                backgroundColor: 'transparent',
                                '&:hover': {
                                    backgroundColor: isDarkMode ? '#2d3a52' : '#f5f5f5',
                                },
                                '&[aria-selected="true"]': {
                                    backgroundColor: isDarkMode ? '#2d3a52' : '#e3f2fd',
                                },
                                '&.Mui-focused': {
                                    backgroundColor: isDarkMode ? '#2d3a52' : '#f5f5f5',
                                },
                            },
                            '& .MuiAutocomplete-loading': {
                                color: isDarkMode ? '#b0bec5' : '#666',
                            },
                            '& .MuiAutocomplete-noOptions': {
                                color: isDarkMode ? '#b0bec5' : '#666',
                            },
                        }
                    }
                }}
                sx={{
                    marginTop: 0.5,
                    marginLeft: -0.2,
                    '& fieldset': {
                        borderRadius: borderChange ? 2 : 7,
                        borderColor: isDarkMode ? '#3d4a62' : 'gray',
                        borderWidth: 2,
                        height: 43.5,
                    },
                    '& .Mui-disabled .MuiOutlinedInput-notchedOutline':{
                        borderRadius: borderChange ? 2 : 7,
                        borderColor: isDarkMode ? '#3d4a62 !important' : '#808080 !important',
                        border: 1,
                        background: isDarkMode ? '#1F2A40' : '#f2f2f2',
                    },
                    '& input': {
                        color: isDarkMode ? '#fff' : '#000',
                    },
                    '& .MuiAutocomplete-popupIndicator': {
                        color: isDarkMode ? '#b0bec5' : 'inherit',
                    },
                    '& .MuiAutocomplete-clearIndicator': {
                        color: isDarkMode ? '#b0bec5' : 'inherit',
                    },
                }}
                renderInput={(params) => (
                    <TextField
                        focused
                        autoComplete='off'
                        {...params}
                        onChange={(e)=>setTextSearch(e.target.value)}
                        InputProps={{
                            ...params.InputProps,
                            type: 'search',
                            startAdornment:(
                                <SearchIcon sx={{color: isDarkMode ? '#b0bec5' : '#000',marginTop:-1}} size={20} />
                            ),
                            endAdornment: (
                            <Fragment>
                                {isLoading ? <CircularProgress sx={{color: isDarkMode ? '#64B5F6' : '#000',marginTop:-1}} size={20} /> : null}
                                {params.InputProps.endAdornment}
                            </Fragment>
                            ),
                        }}
                        sx={{
                            '& fieldset': {
                                borderRadius: 20
                            },
                            '& .MuiOutlinedInput-root': {
                                '&.Mui-focused fieldset': {
                                    borderColor: isDarkMode ? '#64B5F6' : 'gray',
                                },
                            },
                            '& input': {
                                marginTop: -1,
                                color: isDarkMode ? '#fff' : '#000',
                            },
                        }}
                    />
                )}
                renderOption={(props,option)=>{
                    let cortarTitulo = option?.tituloCard;
                    let cortarDescr = option?.descripCard?.replace(/<[^>]*>?/gm, '');
                    cortarDescr = cortarDescr?.replace(/&nbsp[;]?/ig, '');
                    if(cortarTitulo?.length > 30){
                        cortarTitulo = `${cortarTitulo?.substring(0,32)}...`
                    }
                    if(cortarDescr?.length > 80){
                        cortarDescr = `${cortarDescr?.substring(0,80)}...`
                    }
                    return (
                        <CardSearchNav
                            itemsProsp={props}
                            item={option}
                            descripcion={cortarDescr}
                            titulo={cortarTitulo}
                            key={option?.keyCard}
                            onClick={onClick}
                            isDarkMode={isDarkMode}
                        />
                    )
                }}
            />
        </Box>
    );
};

InputSearchIdCompleto.defaultProps = {
    isClearable: false,
    value: null
};

export default InputSearchIdCompleto;